import { CommandItem, CommandShortcut } from '@/components/ui/command'
import type { Destination } from '@/config/navigationDestinations'

export interface PaletteRowData {
  icon: Destination['icon']
  label: string
  /**
   * cmdk's identity for the row, and part of what it scores. Must be unique
   * across the whole palette and should read as words — every character in it
   * can satisfy a fuzzy query.
   */
  value: string
  /** Extra search terms cmdk scores alongside the item's value. */
  keywords?: string[]
  /** Shown right-aligned in monospace. */
  hint?: string
  /**
   * Keep the row visible whatever is typed (it doesn't count as a match).
   * Left undefined, cmdk falls back to the enclosing group's `forceMount`, so
   * pass `false` to opt a row out inside a force-mounted group.
   */
  forceMount?: boolean
}

/** The one row shape every palette group renders, "Jump to" included. */
export function PaletteRow({
  icon: Icon,
  label,
  value,
  keywords,
  hint,
  forceMount,
  onSelect,
}: PaletteRowData & { onSelect: (value: string) => void }) {
  return (
    <CommandItem
      value={value}
      keywords={keywords}
      forceMount={forceMount}
      onSelect={onSelect}>
      <Icon />
      <span className="truncate">{label}</span>
      {hint ? (
        <CommandShortcut className="font-mono tracking-normal">
          {hint}
        </CommandShortcut>
      ) : null}
    </CommandItem>
  )
}
